var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mt-6"
};
const _hoisted_2 = { class: "columns" };
const _hoisted_3 = { class: "column" };
const _hoisted_4 = { class: "label" };
const _hoisted_5 = {
    key: 0,
    class: "ml-2"
};
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-pen" }, null, -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { class: "ml-1" }, "Edit", -1);
const _hoisted_8 = [
    _hoisted_6,
    _hoisted_7
];
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-plus" }, null, -1);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("span", { class: "ml-1" }, "Add", -1);
const _hoisted_11 = [
    _hoisted_9,
    _hoisted_10
];
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-trash" }, null, -1);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("span", { class: "ml-1" }, "Remove", -1);
const _hoisted_14 = [
    _hoisted_12,
    _hoisted_13
];
const _hoisted_15 = { key: 1 };
const _hoisted_16 = ["innerHTML"];
const _hoisted_17 = { key: 2 };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("span", null, "None", -1);
const _hoisted_19 = [
    _hoisted_18
];
const _hoisted_20 = { class: "column" };
const _hoisted_21 = { key: 0 };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Fulfillment", -1);
const _hoisted_23 = {
    key: 0,
    class: "columns"
};
const _hoisted_24 = { class: "column" };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Overridden PDF", -1);
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("div", { class: "column" }, null, -1);
const _hoisted_27 = {
    key: 1,
    class: "columns"
};
const _hoisted_28 = { class: "column" };
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-eye mr-3" }, null, -1);
const _hoisted_30 = {
    key: 0,
    class: "column"
};
const _hoisted_31 = {
    key: 0,
    class: "message is-small is-danger"
};
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("div", { class: "message-header" }, [
    /*#__PURE__*/ _createElementVNode("p", null, "Network Admin Controls")
], -1);
const _hoisted_33 = { class: "message-body" };
const _hoisted_34 = {
    key: 0,
    class: "column"
};
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("p", { class: "is-danger" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, " Do you wish to create a copy of this application? ")
], -1);
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("p", { class: "pt-2" }, " This may incur additional processing fees, and should generally only be done when an application needs to be amended and resubmitted after its initial mailing. ", -1);
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Message", -1);
const _hoisted_38 = { class: "control" };
import { ref } from "vue";
import { doApiAction } from "@/core/api";
import { isNetworkAdmin } from "@/core/session";
import ApplicationModalDialogCollection from "./ApplicationModalDialogCollection.vue";
import ApplicationActionButtonCollection from "./ApplicationActionButtonCollection.vue";
import ApplicationStatusCard from "./ApplicationStatusCard.vue";
import ApplicationFulfillmentTracker from './ApplicationFulfillmentTracker.vue';
import MarkdownIt from "markdown-it";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ApplicationHeaderSection',
    props: {
        applicationTypeName: {},
        title: {},
        createdAt: {},
        status: {},
        statusTransitions: {},
        setStatus: { type: Function },
        keyDocumentAttachments: {},
        uploadKeyDocument: { type: Function },
        deleteKeyDocument: { type: Function },
        getAttachmentViewLink: { type: Function },
        statusMessage: {},
        setStatusMessage: { type: Function },
        deleteStatusMessage: { type: Function },
        statusReport: {},
        fulfillment: {},
        overriddenPdf: {},
        setOverriddenPdf: { type: Function },
        deleteOverriddenPdf: { type: Function },
        clone: { type: Function },
        getPdfViewLink: { type: Function },
        underlyingApplication: {},
        submitBirthRecordByVirtualMail: { type: Function },
        generateShippingLabel: { type: Function },
        downloadShippingLabel: { type: Function },
        submitGeorgiaBenefitsByFax: { type: Function }
    },
    setup(__props) {
        const props = __props;
        const inProgressAction = ref(null);
        /*
         * Application Status
         */
        const showChangeStatusConfirmation = ref(null);
        const changeRequestStatus = (status) => {
            if (inProgressAction.value)
                return;
            showChangeStatusConfirmation.value = status;
        };
        // -- Actually actions a status change
        const doChangeRequestStatus = (status) => {
            showChangeStatusConfirmation.value = null;
            doApiAction(inProgressAction, `changeRequestStatus.${status}`, "Status updated", "Failed to update status", () => __awaiter(this, void 0, void 0, function* () { return props.setStatus(status); }));
        };
        const removeStatusMessage = () => {
            doApiAction(inProgressAction, `removeStatusMessage`, "Message removed", "Failed to remove message", () => __awaiter(this, void 0, void 0, function* () { return props.deleteStatusMessage(); }));
        };
        const showSetStatusMessageModal = ref(false);
        const newStatusMessage = ref("");
        const notifyCitizen = ref(true);
        const doSetStatusMessage = (message, notifyCitizen) => {
            doApiAction(inProgressAction, `setStatusMessage`, "Message set", "Failed to set message", () => props.setStatusMessage(message, notifyCitizen).then(() => showSetStatusMessageModal.value = false));
        };
        const showCloneRequestModal = ref(false);
        const doCloneRequest = () => {
            showCloneRequestModal.value = false;
            doApiAction(inProgressAction, `clone`, "Request cloned", "Failed to clone request", () => __awaiter(this, void 0, void 0, function* () { return props.clone(); }));
        };
        const downloadApplicationPDF = () => {
            doApiAction(inProgressAction, "downloadPdf", null, "Failed to download PDF", () => props.getPdfViewLink().then((pdfViewLink) => window.open(pdfViewLink)));
        };
        const doSetOverriddenPdf = (uploadInfo) => {
            doApiAction(inProgressAction, "setOverriddenPdf", "Overridden PDF uploaded", "Failed to upload overridden PDF", () => props.setOverriddenPdf(uploadInfo.file).finally(() => uploadInfo.onDone()));
        };
        const doDeleteOverriddenPdf = () => {
            doApiAction(inProgressAction, "deleteOverriddenPdf", "Overridden PDF deleted", "Failed to delete overridden PDF", props.deleteOverriddenPdf);
        };
        return (_ctx, _cache) => {
            const _component_LoadingSpinner = _resolveComponent("LoadingSpinner");
            const _component_DocumentUploadWidget = _resolveComponent("DocumentUploadWidget");
            const _component_SaveButton = _resolveComponent("SaveButton");
            const _component_HeaderSectionLayout = _resolveComponent("HeaderSectionLayout");
            const _component_ModalDialog = _resolveComponent("ModalDialog");
            const _component_FormCheckboxField = _resolveComponent("FormCheckboxField");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_component_HeaderSectionLayout, null, {
                    fields: _withCtx(() => [
                        _createVNode(ApplicationStatusCard, {
                            application: _ctx.statusReport,
                            changeStatus: _ctx.setStatus ? changeRequestStatus : undefined,
                            attachments: _ctx.keyDocumentAttachments,
                            uploadAttachment: _ctx.uploadKeyDocument,
                            deleteAttachment: _ctx.deleteKeyDocument,
                            getAttachmentViewLink: _ctx.getAttachmentViewLink,
                            downloadApplicationPDF: downloadApplicationPDF,
                            underlyingApplication: _ctx.underlyingApplication,
                            submitBirthRecordByVirtualMail: _ctx.submitBirthRecordByVirtualMail,
                            generateShippingLabel: _ctx.generateShippingLabel,
                            downloadShippingLabel: _ctx.downloadShippingLabel,
                            submitGeorgiaBenefitsByFax: _ctx.submitGeorgiaBenefitsByFax
                        }, null, 8, ["application", "changeStatus", "attachments", "uploadAttachment", "deleteAttachment", "getAttachmentViewLink", "underlyingApplication", "submitBirthRecordByVirtualMail", "generateShippingLabel", "downloadShippingLabel", "submitGeorgiaBenefitsByFax"]),
                        (_unref(isNetworkAdmin)())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _createElementVNode("label", _hoisted_4, [
                                            _createTextVNode(" Status Message "),
                                            (!inProgressAction.value)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                                    (_ctx.statusMessage)
                                                        ? (_openBlock(), _createElementBlock("a", {
                                                            key: 0,
                                                            onClick: _cache[0] || (_cache[0] = ($event) => { newStatusMessage.value = _ctx.statusMessage; showSetStatusMessageModal.value = true; })
                                                        }, _hoisted_8))
                                                        : (_openBlock(), _createElementBlock("a", {
                                                            key: 1,
                                                            onClick: _cache[1] || (_cache[1] = ($event) => { newStatusMessage.value = ''; showSetStatusMessageModal.value = true; })
                                                        }, _hoisted_11)),
                                                    (_ctx.statusMessage)
                                                        ? (_openBlock(), _createElementBlock("a", {
                                                            key: 2,
                                                            onClick: _cache[2] || (_cache[2] = ($event) => (removeStatusMessage())),
                                                            class: "ml-3"
                                                        }, _hoisted_14))
                                                        : _createCommentVNode("", true)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        (inProgressAction.value == 'setStatusMessage')
                                            ? (_openBlock(), _createBlock(_component_LoadingSpinner, {
                                                key: 0,
                                                size: "small"
                                            }))
                                            : (_ctx.statusMessage)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                    _createElementVNode("div", {
                                                        style: { "background-color": "#dadada", "padding": "0.5rem", "border-radius": "0.5rem" },
                                                        innerHTML: new (_unref(MarkdownIt))().render(_ctx.statusMessage)
                                                    }, null, 8, _hoisted_16)
                                                ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                                    ]),
                                    _createElementVNode("div", _hoisted_20, [
                                        (_unref(isNetworkAdmin)() && _ctx.fulfillment)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                _hoisted_22,
                                                _createVNode(ApplicationFulfillmentTracker, { fulfillment: _ctx.fulfillment }, null, 8, ["fulfillment"])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                (_ctx.setOverriddenPdf)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                        _createElementVNode("div", _hoisted_24, [
                                            _hoisted_25,
                                            _createVNode(_component_DocumentUploadWidget, {
                                                singleDocument: _ctx.overriddenPdf,
                                                onDelete: doDeleteOverriddenPdf,
                                                onUpload: doSetOverriddenPdf
                                            }, null, 8, ["singleDocument"])
                                        ]),
                                        _hoisted_26
                                    ]))
                                    : _createCommentVNode("", true),
                                (_ctx.getPdfViewLink)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                        _createElementVNode("div", _hoisted_28, [
                                            _createElementVNode("a", {
                                                class: _normalizeClass(["button is-link", { 'is-loading': inProgressAction.value == 'downloadPdf' }]),
                                                onClick: _cache[3] || (_cache[3] = ($event) => (downloadApplicationPDF()))
                                            }, [
                                                _hoisted_29,
                                                _createTextVNode(" Download Application PDF ")
                                            ], 2)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    networkAdminControls: _withCtx(() => [
                        (_unref(isNetworkAdmin)())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                (_unref(isNetworkAdmin)())
                                    ? (_openBlock(), _createElementBlock("article", _hoisted_31, [
                                        _hoisted_32,
                                        _createElementVNode("div", _hoisted_33, [
                                            _createVNode(_component_SaveButton, {
                                                label: "Copy This Request",
                                                icon: "fa-clone",
                                                action: "clone",
                                                inProgressAction: inProgressAction.value,
                                                onClick: _cache[4] || (_cache[4] = ($event) => (showCloneRequestModal.value = true))
                                            }, null, 8, ["inProgressAction"])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    partnerControls: _withCtx(() => [
                        (_unref(isNetworkAdmin)())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                _createVNode(ApplicationActionButtonCollection, {
                                    inProgressAction: inProgressAction.value,
                                    status: _ctx.status,
                                    statusTransitions: _ctx.statusTransitions,
                                    onChangeRequestStatus: _cache[5] || (_cache[5] = ($event) => (changeRequestStatus($event)))
                                }, null, 8, ["inProgressAction", "status", "statusTransitions"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(ApplicationModalDialogCollection, {
                    applicationTypeName: _ctx.applicationTypeName,
                    showChangeStatusConfirmation: showChangeStatusConfirmation.value,
                    onClearConfirmationStatus: _cache[6] || (_cache[6] = ($event) => (showChangeStatusConfirmation.value = null)),
                    onDoChangeRequestStatus: _cache[7] || (_cache[7] = ($event) => (doChangeRequestStatus($event)))
                }, null, 8, ["applicationTypeName", "showChangeStatusConfirmation"]),
                _createVNode(_component_ModalDialog, {
                    active: showCloneRequestModal.value,
                    title: "Create A Copy",
                    severity: "link",
                    allowClose: true,
                    onClose: _cache[8] || (_cache[8] = ($event) => (showCloneRequestModal.value = false)),
                    firstButtonText: "Go Back",
                    firstButtonSeverity: "link",
                    onFirstbuttonselected: _cache[9] || (_cache[9] = ($event) => (showCloneRequestModal.value = false)),
                    secondButtonText: "Create Copy",
                    secondButtonSeverity: "success",
                    onSecondbuttonselected: _cache[10] || (_cache[10] = ($event) => (doCloneRequest()))
                }, {
                    default: _withCtx(() => [
                        _hoisted_35,
                        _hoisted_36
                    ]),
                    _: 1
                }, 8, ["active"]),
                _createVNode(_component_ModalDialog, {
                    active: showSetStatusMessageModal.value,
                    loading: inProgressAction.value == 'setStatusMessage',
                    title: "Set Status Message",
                    severity: "link",
                    allowClose: true,
                    onClose: _cache[13] || (_cache[13] = ($event) => (showSetStatusMessageModal.value = false)),
                    firstButtonText: "Go Back",
                    firstButtonSeverity: "link",
                    onFirstbuttonselected: _cache[14] || (_cache[14] = ($event) => (showSetStatusMessageModal.value = false)),
                    secondButtonText: "Set Message",
                    secondButtonSeverity: "success",
                    onSecondbuttonselected: _cache[15] || (_cache[15] = ($event) => (doSetStatusMessage(newStatusMessage.value, notifyCitizen.value)))
                }, {
                    default: _withCtx(() => [
                        _hoisted_37,
                        _createElementVNode("div", _hoisted_38, [
                            _withDirectives(_createElementVNode("textarea", {
                                class: "textarea",
                                label: "Message",
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((newStatusMessage).value = $event)),
                                autofocus: ""
                            }, null, 512), [
                                [_vModelText, newStatusMessage.value]
                            ])
                        ]),
                        _createVNode(_component_FormCheckboxField, {
                            boxLabel: "Notify Citizen",
                            modelValue: notifyCitizen.value,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((notifyCitizen).value = $event))
                        }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                }, 8, ["active", "loading"])
            ], 64));
        };
    }
});
